module.exports = __webpack_public_path__ + "static/img/continue.822f6a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/continue.png
// module id = gKMn
// module chunks = 1